(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ssk-build-your-setup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ssk-setup')) {
    customElements.define('ssk-setup', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.pending = false;
        this.added = false;
        this.money = new Intl.NumberFormat(this.dataset.locale || 'en', { style:'currency', currency:this.dataset.currency || 'USD' });
        this.rows = Array.from(this.querySelectorAll('[data-setup-row]'));
        this.kayak = this.querySelector('[data-setup-kayak]');
        this.addButton = this.querySelector('[data-setup-add]');
        this.fields = this.querySelector('[data-setup-fields]');
        this.clearButton = this.querySelector('[data-setup-clear]');
        this.status = this.querySelector('[data-setup-status]');
        this.addEventListener('change', () => this.update());
        this.clearButton.addEventListener('click', () => {
          this.rows.forEach(row => { row.querySelector('[data-setup-check]').checked = false; });
          this.status.textContent = '';
          this.update();
        });
        this.addButton.addEventListener('click', () => this.addSetup());
        this.update();
      }
      format(cents) { return this.money.format(cents / 100); }
      selection() {
        const kayak = this.kayak.selectedOptions[0];
        let complete = Boolean(kayak && kayak.value && !kayak.disabled);
        let subtotal = 0;
        const items = new Map();
        if (complete) items.set(kayak.value, { id:kayak.value, quantity:1 });
        for (const row of this.rows) {
          const checked = row.querySelector('[data-setup-check]').checked;
          const option = row.querySelector('[data-setup-variant]').selectedOptions[0];
          const price = row.querySelector('[data-setup-price]');
          price.textContent = option && option.value ? this.format(Number(option.dataset.price)) : this.dataset.from + ' ' + this.format(Number(price.dataset.fromPrice));
          if (!checked) continue;
          if (!option || !option.value || option.disabled) { complete = false; continue; }
          if (!items.has(option.value)) {
            subtotal += Number(option.dataset.price);
            items.set(option.value, { id:option.value, quantity:1 });
          }
        }
        return { complete, subtotal, total:Number(kayak?.dataset.price || 0) + subtotal, items:Array.from(items.values()) };
      }
      update() {
        const state = this.selection();
        this.querySelector('[data-setup-subtotal]').textContent = state.complete ? this.format(state.subtotal) : this.dataset.choose;
        this.querySelector('[data-setup-total]').textContent = state.complete ? this.format(state.total) : this.dataset.choose;
        this.addButton.disabled = this.pending || this.added || !state.complete;
        this.clearButton.disabled = this.pending || this.added || !this.rows.some(row => row.querySelector('[data-setup-check]').checked);
      }
      async addSetup() {
        if (this.pending || this.added) return;
        const state = this.selection();
        if (!state.complete) return;
        this.pending = true;
        this.fields.disabled = true;
        this.addButton.textContent = this.dataset.adding;
        this.status.textContent = '';
        this.update();
        try {
          await new Promise((resolve, reject) => {
            const request = new XMLHttpRequest();
            request.open('POST', this.dataset.cartAddUrl);
            request.timeout = 20000;
            request.setRequestHeader('Content-Type', 'application/json');
            request.setRequestHeader('Accept', 'application/json');
            request.onload = () => {
              try {
                const result = JSON.parse(request.responseText);
                if (request.status < 200 || request.status >= 300) {
                  reject(new Error(typeof result.description === 'string' ? result.description : this.dataset.error));
                } else resolve(result);
              } catch { reject(new Error(this.dataset.error)); }
            };
            request.onerror = request.ontimeout = () => reject(new Error(this.dataset.error));
            request.send(JSON.stringify({ items:state.items }));
          });
          this.added = true;
          this.addButton.hidden = true;
          this.querySelector('[data-setup-view]').hidden = false;
          this.status.textContent = this.dataset.added;
        } catch (error) {
          this.status.textContent = error.message || this.dataset.error;
          this.querySelector('[data-setup-view]').hidden = false;
        } finally {
          this.pending = false;
          this.fields.disabled = this.added;
          this.addButton.textContent = this.dataset.add;
          this.update();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssk-custom-build"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ssk-custom-build')) {
    customElements.define('ssk-custom-build', class extends HTMLElement {
      connectedCallback() {
        if (window.location.hash === '#ssk-custom-build') this.querySelector('details').open = true;
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        document.addEventListener('click', event => {
          if (!event.target.closest('[data-ssk-custom-open]')) return;
          const details = this.querySelector('details');
          if (details) details.open = true;
        }, { signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssk-fishing-team"] && !Shopify.designMode) return;
  try {
    
(() => {
 const hydrate=host => {
  if (!host || !host.dataset.sskPortal || host.dataset.sskHydrated) return;
  host.dataset.sskHydrated='true';
  let portal;
  try { portal = new URL(host.dataset.sskPortal); if(portal.protocol !== 'https:') return; } catch { return; }
  const safe = (value, kinds=['https:']) => { try { const u=new URL(value);return kinds.includes(u.protocol)&&!u.username&&!u.password?u.href:null; } catch {return null;} };
  const el = (tag, cls, text) => { const e=document.createElement(tag);if(cls)e.className=cls;if(text)e.textContent=text;return e; };
  const anchor=(url,label)=>{const a=el('a','',label);a.href=url;return a;};
  const labels={pro:host.dataset.sskTierPro,team:host.dataset.sskTierTeam,ambassador:host.dataset.sskTierAmbassador};

  const updateBanner=async members=>{
    const collage=host.querySelector('.ssk-team__collage');if(!collage)return;
    const shuffled=list=>{const copy=list.slice();for(let i=copy.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[copy[i],copy[j]]=[copy[j],copy[i]];}return copy;};
    const queues=shuffled(members).map(m=>shuffled((m.gallery||[]).map(g=>safe(g.photo)).filter(Boolean)));
    const candidates=[],seen=new Set();
    const add=url=>{if(url&&!seen.has(url)){seen.add(url);candidates.push(url);}};
    for(let round=0;round<12;round++)for(const queue of queues)add(queue[round]);
    shuffled(members).forEach(m=>add(safe(m.photo)));
    collage.querySelectorAll('img').forEach(img=>add(safe(img.currentSrc||img.src)));
    if(!candidates.length)return;
    const loaded=[];
    for(const url of candidates){
      if(loaded.length===5)break;
      const image=new Image();image.alt='';image.decoding='async';
      const ok=await new Promise(resolve=>{const timer=setTimeout(()=>resolve(false),3500);image.onload=()=>{clearTimeout(timer);resolve(true);};image.onerror=()=>{clearTimeout(timer);resolve(false);};image.src=url;});
      if(ok)loaded.push(image);
      if(!host.isConnected)return;
    }
    if(!loaded.length||!host.isConnected)return;
    const tiles=loaded.map(image=>{const tile=el('div','ssk-team__collage-tile');tile.append(image);return tile;});
    collage.replaceChildren(...tiles);
  };

  const loadPublicTeam=()=>new Promise((resolve,reject)=>{
    const script=document.createElement('script');script.src=new URL('/team-feed.js',portal).href;script.async=true;script.referrerPolicy='no-referrer';
    const cleanup=()=>{clearTimeout(timer);window.removeEventListener('ssk:approved-team',receive);script.remove();};
    const receive=event=>{cleanup();resolve(event.detail);};
    const timer=setTimeout(()=>{cleanup();reject(Error('Unavailable'));},8000);
    window.addEventListener('ssk:approved-team',receive,{once:true});
    script.onerror=()=>{cleanup();reject(Error('Unavailable'));};document.head.append(script);
  });
  loadPublicTeam().then(value=>{if(!value||!Array.isArray(value.members))throw Error('Invalid feed');const members=value.members;
    if(members.some(m=>!m||typeof m.name!=='string'||!Object.hasOwn(labels,m.tier)||typeof m.id!=='string'||!Array.isArray(m.gallery||[])||!Array.isArray(m.favorites||[])))throw Error('Invalid profiles');
    updateBanner(members).catch(()=>{});
    const roster=host.querySelector('.ssk-team__body');if(!roster)return;
    const container=el('div','ssk-team__approved-roster');
    for(const tier of ['pro','team','ambassador']){const list=members.filter(m=>m.tier===tier);if(!list.length&&tier!=='ambassador')continue;const group=el('section','ssk-team__tier ssk-team__tier--'+tier);const heading=el('h3','ssk-team__tier-heading',labels[tier]);group.append(heading);if(tier==='ambassador')group.append(el('p','ssk-team__ambassador-intro',host.dataset.sskAmbassadorIntro));const grid=el('div','ssk-team__grid');group.append(grid);if(!list.length){const visit=anchor(portal.href,host.dataset.sskMemberArea+' →');visit.className='ssk-team__profile-link';group.append(visit);}
      for(const m of list){const card=el('article','ssk-team__member'),portrait=el('div','ssk-team__portrait');const image=safe(m.photo);if(image){const img=el('img');img.src=image;img.alt=m.name;img.loading='lazy';img.width=900;img.height=675;portrait.append(img);}card.append(portrait);const content=el('div','ssk-team__member-content');content.append(el('h4','',m.name));if(m.hometown)content.append(el('p','ssk-team__tagline',m.hometown));if(m.kayak)content.append(el('p','ssk-team__kayak',m.kayak));
        const details=el('details','ssk-team__bio'),summary=el('summary','',host.dataset.sskAbout.replace('SSK_MEMBER_NAME',m.name)),plus=el('span','','+');plus.setAttribute('aria-hidden','true');summary.append(plus);details.append(summary);const bio=el('div');bio.append(el('p','',m.bio||host.dataset.sskBioSoon));const full=anchor(new URL('/members/'+encodeURIComponent(m.id),portal).href,host.dataset.sskViewProfile+' →');full.className='ssk-team__profile-link';bio.append(full);details.append(bio);content.append(details);
        const links=el('div','ssk-team__links');for(const [key,label]of Object.entries({instagram:host.dataset.sskInstagram,facebook:host.dataset.sskFacebook,youtube:host.dataset.sskYoutube,tiktok:host.dataset.sskTiktok,website:host.dataset.sskWebsite})){const url=safe(m[key]);if(url)links.append(anchor(url,label));}if(links.childElementCount)content.append(links);card.append(content);grid.append(card);
      }container.append(group);
    }
    const old=roster.querySelectorAll(':scope > .ssk-team__tier, :scope > .ssk-team__approved-roster');const first=old[0];if(first)first.before(container);else roster.append(container);old.forEach(node=>node.remove());
  }).catch(()=>{delete host.dataset.sskHydrated;});
 };
 const mount=scope=>scope.querySelectorAll('[data-ssk-portal]').forEach(hydrate);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true});else mount(document);
 document.addEventListener('shopify:section:load',event=>mount(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssk-standalone-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ssk-standalone-gallery')) {
  customElements.define('ssk-standalone-gallery', class extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), {once: true});
      } else {
        this.initialize();
      }
    }
    initialize() {
      if (this.initialized) return;
      this.initialized = true;
      let cards = Array.from(this.querySelectorAll('[data-photo]'));
      const grid = this.querySelector('.ssk-public-gallery__grid');
      const more = this.querySelector('[data-load-more]');
      const notice = this.querySelector('[data-feed-notice]');
      const upload = this.querySelector('[data-upload-link]');
      const filters = Array.from(this.querySelectorAll('[data-filter]'));
      this.querySelector('[role="group"]').hidden = cards.length === 0;
      const picker = this.querySelector('[data-lake-select]');
      const lakeName = this.querySelector('[data-lake-name]');
      const locationParams=new URLSearchParams(window.location.search);
      let lake=locationParams.get('lake')||'';
      const custom=locationParams.get('customLake')||'';
      if(lake==='other'&&/^[0-9a-f-]{36}$/.test(custom)){lake='custom:'+custom;const option=document.createElement('option');option.value=lake;option.textContent='Custom lake';picker.append(option);}
      let category = 'all';
      const apply = () => {
        let count = 0;
        for (const card of cards) {
          card.hidden = (lake !== '' && !(lake==='other'?card.dataset.lake==='other'||card.dataset.lake.startsWith('custom:'):card.dataset.lake===lake)) || (category !== 'all' && !card.dataset.categories.split(/\s+/).includes(category));
          if (!card.hidden) count++;
        }
        for (const filter of filters) filter.setAttribute('aria-pressed', String(filter.dataset.filter === category));
        const option = Array.from(picker.options).find(option => option.value === lake);
        picker.value = option ? lake : '';
        const uploadUrl=new URL('https://service.strictlysailinc.com/share-photos');if(option&&lake){uploadUrl.searchParams.set('lake',lake.startsWith('custom:')?'other':lake);if(option.dataset.customName){uploadUrl.searchParams.set('customLakeName',option.dataset.customName);uploadUrl.searchParams.set('customLakeLocation',option.dataset.customLocation||'');}}upload.href=uploadUrl.href;
        upload.textContent = option && lake ? this.dataset.uploadLake : this.dataset.uploadAll;
        this.querySelector('[role="group"]').hidden = cards.length === 0;
        lakeName.hidden = !lake;
        lakeName.textContent = option && lake ? option.textContent : this.dataset.unknownLake;
        this.querySelector('[data-clear-lake]').hidden = !lake;
        this.querySelector('[data-empty]').hidden = count !== 0;
        this.querySelector('[data-status]').textContent = this.dataset.countLabel.replace('[count]', String(count));
      };
      this.querySelector('[data-lake-filter]').hidden = false;
      picker.addEventListener('change', () => {
        lake = picker.value;
        const url = new URL(window.location.href);
        if (lake.startsWith('custom:')){url.searchParams.set('lake','other');url.searchParams.set('customLake',lake.slice(7));}else{url.searchParams.delete('customLake');if(lake)url.searchParams.set('lake',lake);else url.searchParams.delete('lake');}
        window.history.replaceState(null, '', url);
        apply();
        loadPhotos();
      });
      this.addEventListener('click', event => {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('[data-filter]');
        if (!button || !this.contains(button)) return;
        category = button.dataset.filter;
        apply();
        loadPhotos();
      });
      let cursor = null;
      let sequence = 0;
      let controller;
      const loadPhotos = async (append = false) => {
        const request = ++sequence;
        if (controller) controller.abort();
        controller = new AbortController();
        if (!append) {
          this.querySelectorAll('[data-customer-photo]').forEach(card => card.remove());
          cards = Array.from(this.querySelectorAll('[data-photo]'));
          cursor = null;
          apply();
        }
        more.hidden = true;
        notice.hidden = true;
        if (lake && !Array.from(picker.options).some(option => option.value === lake)) return;
        const url = new URL('https://service.strictlysailinc.com/api/community-gallery');
        url.searchParams.set('limit', '24');
        if (lake.startsWith('custom:')){url.searchParams.set('lake','other');url.searchParams.set('customLake',lake.slice(7));}else if(lake)url.searchParams.set('lake',lake);
        if (category !== 'all') url.searchParams.set('category', category);
        if (append && cursor) url.searchParams.set('cursor', cursor);
        try {
          const response = await fetch(url, {credentials: 'omit', cache: 'no-store', signal: controller.signal});
          if (!response.ok) throw new Error('unavailable');
          const data = await response.json();
          if (request !== sequence) return;
          if (!Array.isArray(data.items) || data.items.length > 24) throw new Error('invalid');
          for(const entry of Array.isArray(data.customLakes)?data.customLakes.slice(0,60):[]){if(!/^[0-9a-f-]{36}$/.test(entry.id)||typeof entry.name!=='string'||entry.name.length>120||typeof entry.location!=='string'||entry.location.length>120)continue;const value='custom:'+entry.id;let option=Array.from(picker.options).find(o=>o.value===value);if(!option){option=document.createElement('option');option.value=value;picker.append(option);}option.textContent=entry.name+' — '+entry.location;option.dataset.customName=entry.name;option.dataset.customLocation=entry.location;}
          const fragment = document.createDocumentFragment();
          for (const item of data.items) {
            if (typeof item.imageUrl !== 'string' || !/^https:\/\/service\.strictlysailinc\.com\/api\/shared-photo\/[0-9a-f-]{36}$/.test(item.imageUrl)) continue;
            if(typeof item.id!=='string'||! /^[0-9a-f-]{36}~customer$/.test(item.id)||item.imageUrl!=='https://service.strictlysailinc.com/api/shared-photo/'+item.id.split('~')[0])continue;
            if (typeof item.caption !== 'string' || item.caption.length > 240 || !Array.isArray(item.categories)) continue;
            const card = document.createElement('figure');
            card.dataset.photo = '';
            card.dataset.customerPhoto = '';
            card.dataset.lake=typeof item.customLakeId==='string'&&/^[0-9a-f-]{36}$/.test(item.customLakeId)?'custom:'+item.customLakeId:typeof item.lakeId==='string'?item.lakeId:'';
            card.dataset.categories = item.categories.filter(value => ['sailing','kayaking','fishing'].includes(value)).join(' ');
            const img = document.createElement('img');
            img.src = item.imageUrl;
            img.alt = item.caption;
            img.loading = 'lazy';
            img.draggable = false;
            img.addEventListener('error', () => { card.remove(); cards = cards.filter(value => value !== card); apply(); }, {once:true});
            const caption = document.createElement('figcaption');
            caption.textContent=item.caption+(item.lakeId==='other'&&typeof item.lakeName==='string'?' · '+item.lakeName+(typeof item.location==='string'?' — '+item.location:''):'');
            const requestLink=document.createElement('a');requestLink.className='ssk-public-gallery__request';requestLink.textContent='Request to use this photo';requestLink.href='https://service.strictlysailinc.com/request-photo-use?photo='+encodeURIComponent(item.id);
            card.append(img,caption,requestLink);
            fragment.append(card);
            cards.push(card);
          }
          grid.append(fragment);
          cursor = typeof data.nextCursor === 'string' && /^[0-9a-f-]{36}~customer$/.test(data.nextCursor) ? data.nextCursor : null;
          more.hidden = !cursor;
          apply();
        } catch (error) {
          if (request !== sequence || error.name === 'AbortError') return;
          notice.textContent = this.dataset.feedError;
          notice.hidden = false;
        }
      };
      more.addEventListener('click', () => loadPhotos(true));
      window.addEventListener('pageshow', event => { if (event.persisted) loadPhotos(); });
      apply();
      loadPhotos();
      for (const type of ['contextmenu', 'dragstart']) {
        this.addEventListener(type, event => {
          if (event.target instanceof Element && event.target.matches('[data-photo] img')) event.preventDefault();
        });
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssk-video-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ssk-video-hero')) {
  customElements.define('ssk-video-hero', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 599px)');
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.userPaused = this.motion.matches || Boolean(navigator.connection?.saveData);
      this.visible = true;
      this.revision = 0;
      this.button.addEventListener('click', () => {
        this.userPaused = !this.video.paused;
        if (this.userPaused) this.video.pause(); else this.refresh();
        this.updateButton();
      }, opts);
      this.mobile.addEventListener('change', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.refresh(), 180);
      }, opts);
      this.motion.addEventListener('change', () => {
        this.userPaused = this.motion.matches;
        if (this.userPaused) {
          this.revision++;
          this.cancelPending();
          this.video.pause(); this.video.removeAttribute('src'); this.video.load();
          this.video.classList.remove('is-visible');
          this.updateButton();
        } else this.refresh();
      }, opts);
      document.addEventListener('visibilitychange', () => this.applyPlayback(), opts);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.applyPlayback();
      });
      this.observer.observe(this);
      this.bindVideo(this.video);
      this.refresh();
    }
    source() { return this.mobile.matches && this.dataset.mobile ? this.dataset.mobile : this.dataset.desktop; }
    shouldPlay() { return !this.userPaused && this.visible && !document.hidden; }
    updateButton() { this.button.textContent = this.video.paused ? this.dataset.play : this.dataset.pause; }
    bindVideo(video) {
      for (const name of ['playing', 'pause']) video.addEventListener(name, () => {
        if (video === this.video) this.updateButton();
      }, { signal: this.abort.signal });
    }
    applyPlayback() {
      if (!this.shouldPlay()) this.video.pause();
      else this.refresh();
    }
    cancelPending() {
      if (this.pending) {
        this.pending.pause(); this.pending.removeAttribute('src'); this.pending.load(); this.pending.remove();
        this.pending = null;
      }
    }
    waitFor(video, event) {
      return new Promise((resolve, reject) => {
        const clean = () => { clearTimeout(timer); video.removeEventListener(event, done); video.removeEventListener('error', fail); this.abort.signal.removeEventListener('abort', fail); };
        const done = () => { clean(); resolve(); };
        const fail = () => { clean(); reject(new Error('Video unavailable')); };
        const timer = setTimeout(fail, 12000);
        video.addEventListener(event, done, { once: true });
        video.addEventListener('error', fail, { once: true });
        this.abort.signal.addEventListener('abort', fail, { once: true });
      });
    }
    async refresh() {
      const source = this.source();
      this.button.hidden = !source;
      if (!source) { this.video.pause(); return; }
      if (this.video.getAttribute('src') === source) {
        if (this.pending) { this.revision++; this.cancelPending(); }
        if (this.shouldPlay()) this.video.play().catch(() => this.updateButton());
        return;
      }
      if (this.pending?.getAttribute('src') === source) return;
      if (this.userPaused && !this.video.getAttribute('src')) return;
      const revision = ++this.revision;
      this.cancelPending();
      const previous = this.video;
      const next = previous.cloneNode(false);
      next.classList.remove('is-visible');
      next.muted = true;
      next.preload = 'auto';
      next.removeAttribute('src');
      this.pending = next;
      previous.after(next);
      try {
        const loaded = this.waitFor(next, 'loadedmetadata');
        next.src = source; next.load();
        await loaded;
        if (revision !== this.revision) return;
        const target = previous.currentTime % next.duration;
        if (target > 0.01) {
          const seeked = this.waitFor(next, 'seeked'); next.currentTime = target; await seeked;
        } else if (next.readyState < 2) await this.waitFor(next, 'loadeddata');
        if (revision !== this.revision) return;
        if (this.shouldPlay()) await next.play();
        if (revision !== this.revision) return;
        this.video = next; this.pending = null; this.bindVideo(next);
        next.classList.add('is-visible');
        this.button.hidden = false; this.updateButton();
        setTimeout(() => { previous.pause(); previous.removeAttribute('src'); previous.load(); previous.remove(); }, 200);
      } catch (error) {
        if (revision === this.revision) { this.cancelPending(); this.updateButton(); }
      }
    }
    disconnectedCallback() {
      this.revision++; clearTimeout(this.resizeTimer); this.abort?.abort(); this.observer?.disconnect();
      this.cancelPending(); this.video?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
